export default __webpack_public_path__ + "locales/tr/Settings.json?hash=be8b124577ee35bcf9077aacdecb8658";